export default __webpack_public_path__ + "static/media/2.2ff39e76.jpg";